<template>
  <v-dialog
      :dialog="dialog"
      max-width="500px"
      transition="dialog-top-transition"
    >
      <v-card rounded="xl">
        <v-card-title class="d-flex justify-space-between align-center ">
          <ContactPopup :contact_id="selectedEvent.contact_id" />
          <div class="text-medium-emphasis ps-2 flex-grow-1 min-width-0 date-time-responsive" style="display: inline">
            {{ simpleDateTimeFormat(selectedEvent.date) }} to
            {{ formatTime(selectedEvent.end) }}
          </div>
          <v-btn icon="mdi-close" variant="text" @click="closeDialog"></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Provider -->
          <div class="text-h6 mb-2">
            <strong>Provider:</strong> {{ selectedEvent.od_json[0].provAbbr }}
          </div>

          <!-- Patient & Appointment Info -->
          <div class="text-subtitle-1">
            <div>
              <strong>Patient:</strong> {{ selectedEvent.first_name }}
              {{ selectedEvent.last_name }}
            </div>
            <div>
              <strong>Clinic:</strong>
              {{ clinics[selectedEvent.od_json[0].ClinicNum].clinicName }}
            </div>
            <div>
              <strong>Operatory:</strong>
              {{ getOpName(selectedEvent.operatoryId) }}
            </div>
            <div>
              <strong>Appt Status:</strong>
              {{ selectedEvent.od_json[0].AptStatus }}
            </div>
            <div>
              <strong>Confirmed:</strong>
              {{ selectedEvent.od_json[0].confirmed }}
            </div>
            <div>
              <strong>Procedure:</strong>
              {{ selectedEvent.od_json[0].ProcDescript }}
            </div>
            <div>
              <strong>Is New Patient:</strong>
              {{
                selectedEvent.od_json[0].IsNewPatient == "true" ? "Yes" : "No"
              }}
            </div>
          </div>

          <!-- Divider -->
          <v-divider class="my-3"></v-divider>

          <!-- Notes -->
          <div v-if="selectedEvent.od_json[0].Note" class="text-caption">
            <strong>Notes:</strong> {{ selectedEvent.od_json[0].Note }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import ContactPopup from "@/components/Avatar/ContactPopup";
import UserPopup from "../Avatar/UserPopup.vue";
import { mapGetters } from "vuex";
import dayjsMixin from "@/mixins/dayjsMixin";
import colorMixin from "@/mixins/colorMixin";
export default {
  name: "ODAppointmentCard",
   mixins: [dayjsMixin, colorMixin],
  data() {
    return {
      
    };
  },
  props: {
    dialog: { type: Boolean, default: false },
    selectedEvent: { type: Object, required: true },
    schedules:{type: Array, default : []}
  },
  components:{
    ContactPopup,
    UserPopup
  },
  computed :{
    ...mapGetters("calendar",["currentCalendar","canEditCalendar","isODCalendar","isDSSCalendar","clinics"]),
    getOpName() {
      return (op) => {
        const operatory = this.schedules.find((schedule) => schedule.id === op);
        return operatory ? operatory.label : "Unknown";
      };
    },
  },
  methods: {
    formatTime(time) {
      return this.dayjs(time).format("h:mm A");
    },
    formatDate(date) {
      return this.dayjs(date).format("ddd YYYY-MM-DD");
    },
    closeDialog() {
      this.$emit("close");
    },
  }
}
</script>

<style>
.card-title-responsive {
  padding-left: 16px;
  padding-right: 16px;
}
.date-time-responsive {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 600px) {
  .date-time-responsive {
    font-size: 0.85rem;
    margin-top: 4px;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>